// extracted by mini-css-extract-plugin
export var banner = "_2y-0";
export var icon = "_2y-1";
export var message = "_2y-2";